import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import IDRRouting from 'components/Resources/IDRRouting';
import SettingGrid from 'components/Resources/SettingGrid';
import FloatingActionButton from 'components/Shared/FloatingActionButton';
import AddResource from './AddResource';
import { addResource } from 'utils/ResourcesUtils';
import AuthCheck from 'components/Shared/AuthCheck';

const tabs = [
  new Tab({ label: "Setting", value: "SettingGrid", scope: "Resources", action: "read" }),
  new Tab({ label: "Add", value: "AddResource", scope: "Resources", action: "create" }),
  new Tab({ label: "IDR Routing", value: "IDRRoutingGrid", scope: "Resources", action: "update" }),
]

const Resources = () => {
  const [activeTab, setActiveTab] = useState("SettingGrid");

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      {(() => {
        switch (activeTab) {
          case "SettingGrid": return <SettingGrid />;
          case "AddResource": return <AddResource callback={() => setActiveTab("SettingGrid")} submitAjaxFunc={addResource} />;
          case "IDRRoutingGrid": return <IDRRouting submitAjaxFunc={SettingGrid} />;
          default: return <SettingGrid />;
        }
      })()}

      <AuthCheck scope="Resources" action="create"><FloatingActionButton onClick={() => setActiveTab("AddResource")}><AddIcon /></FloatingActionButton></AuthCheck>
    </TabbedPage>
  )
}

export default Resources;